import {
  CustomFormItemProps,
  Select,
} from '@trufla-technology/trumarket-react-design-system';

export type CustomSelectProps = CustomFormItemProps<string> & {
  disabled?: boolean;
};
export const currencies = [
  {
    label: 'USA Dollar (USD)',
    value: 'USD',
  },
  {
    label: 'Canada Dollar (CAD)',
    value: 'CAD',
  },
  {
    label: 'Great Britain Pound (GBP)',
    value: 'GBP',
  },
];

export const CurrencySelect = ({
  onChange,
  value,
  disabled,
}: CustomSelectProps) => {
  return (
    <Select disabled={disabled} onChange={onChange} value={value}>
      {currencies.map(({ label, value }) => (
        <option key={`currency-option-${value}`} value={value}>
          {label}
        </option>
      ))}
    </Select>
  );
};
